/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetYourProfileQueryResponse,
  GetYourProfile401,
} from "../types/GetYourProfile.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { getYourProfile } from "../client/getYourProfile.ts"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getYourProfileQueryKey = () => [{ url: "/me/profile" }] as const

export type GetYourProfileQueryKey = ReturnType<typeof getYourProfileQueryKey>

export function getYourProfileQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getYourProfileQueryKey()
  return queryOptions<
    GetYourProfileQueryResponse,
    ResponseErrorConfig<GetYourProfile401>,
    GetYourProfileQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getYourProfile(config)
    },
  })
}

/**
 * @summary Get your profile
 * {@link /me/profile}
 */
export function useGetYourProfile<
  TData = GetYourProfileQueryResponse,
  TQueryData = GetYourProfileQueryResponse,
  TQueryKey extends QueryKey = GetYourProfileQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetYourProfileQueryResponse,
        ResponseErrorConfig<GetYourProfile401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getYourProfileQueryKey()

  const query = useQuery(
    {
      ...getYourProfileQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetYourProfile401>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
